//Created by wangshuyi on 07/03/2018.

'use strict';
import axios from 'axios'
import dolphinCoreConfig from '../config';

const ajax = function (params) {
  let param = Object.assign({}, dolphinCoreConfig.erp, params);

  if (!param.forceUrl && !new RegExp(`^${this.$Dolphin.path.erpPath}`).test(param.url)) {
    param.url = this.$Dolphin.path.erpPath + param.url;
  }

  if (param.pathData) {
    for (let key in param.pathData) {
      param.url = param.url.replace(`{${key}}`, param.pathData[key]);
    }
  }

  let token = this.$store && this.$store.state.token;
  let showLoadingTimeout;
  if (param.loading && typeof this.$store.state.loading === 'boolean') {
    if(params.loadingTimeout){
      showLoadingTimeout = setTimeout(() => {
        this.$store.commit('setLoading', true);
      }, 500);
    }else{
      this.$store.commit('setLoading', true);
    }
  }

  return axios(Object.assign({
    transformRequest: [function (data) {
      let ret = '';
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
      }
      return ret;
    }],
    headers: {"Content-Type": "application/x-www-form-urlencoded"},
  }, param)).then(({data}) => {
    if (data['code'] && data['code'] !== "0") {
      throw data;
    }

    return data;
  }).catch(e => {
    if (param.showMessage) {
      if(window.$DolAntPage){
        window.$DolAntPage.$error({
          title: '系统提示',
          content: e.message,
        });
      }else if(window.$DolVantPage){
        window.$DolVantPage.$dialog.alert({
          title: '系统提示',
          content: e.message,
        });
      }else{
        alert(e.message);
      }
    }
    throw e;
  }).finally(() => {
    if (param.loading && this.$store && typeof this.$store.state.loading === 'boolean') {
      if(showLoadingTimeout){
        clearTimeout(showLoadingTimeout);
      }
      this.$store.commit('setLoading', false);
    }
  });
};


export default ajax;
